import { Component } from '@angular/core';

@Component({
	selector: 'map-ya-polygon',
	templateUrl: './map-ya-polygon.component.html',
	styleUrls: ['./map-ya-polygon.component.scss']
})
export class MapYaPolygonComponent {

	private drawingPolygonControlButton;
	private drawingPolygon;
	private drawingPolygonStateMonitor;

	private getSelectedRequestsButton;

	private isCompletedPolygon: boolean = false;

	protected drawingPolygonControlButtonData = {
		content: 'Режим выделения'
	};

	protected drawingPolygonControlButtonOptions = {
		float: 'right',
		floatIndex: 5,
		maxWidth: 150,
		size: 'medium'
	};

	protected drawingPolygonProperties = {};

	protected drawingPolygonOptions = {
		interactivityModel: 'default#geoObject',
		cursor: 'pointer',
		draggable: false,
		hasHint: false,
		editorDrawingCursor: "crosshair",
		editorMaxPoints: 5,
		fillColor: '#9FAD9F',
		fillOpacity: '0.5',
		strokeColor: '#A1A18F',
		strokeWidth: 2,
		editorMenuManager: (items) => []
	};

	protected getSelectedRequestsButtonData = {
		content: 'Отобрать заявки'
	};

	constructor() {
		
	}


	public deselectGetRequestButton() {
		if (this.getSelectedRequestsButton) {
			this.getSelectedRequestsButton.deselect();
		}
	}

	public clear(yaMap: any) {
		if (this.drawingPolygon) {
			yaMap.geoObjects.remove(this.drawingPolygon);
		}

		this.drawingPolygonControlButton.deselect();

		this.removeGetRequestsButton(yaMap);
	}

	private removeGetRequestsButton(yaMap: any): void {
		yaMap.controls.remove(this.getSelectedRequestsButton);
	}

	private createCustomButton(ymaps: any, useOnSelectedButtonClass: boolean = true) {
		const onSelectedButtonCssClass = useOnSelectedButtonClass ? '{% if state.selected %} map-btn-selected{% endif %}' : '';
		return ymaps.templateLayoutFactory.createClass(
			`
				<button class="btn map-btn${onSelectedButtonCssClass}">{{ data.content }}</button/>
			`
		);
	}
}
